import { render, staticRenderFns } from "./NewReinsurandeDicDetails.vue?vue&type=template&id=1e73d56c&scoped=true&"
import script from "./NewReinsurandeDicDetails.vue?vue&type=script&lang=js&"
export * from "./NewReinsurandeDicDetails.vue?vue&type=script&lang=js&"
import style0 from "./NewReinsurandeDicDetails.vue?vue&type=style&index=0&id=1e73d56c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e73d56c",
  null
  
)

export default component.exports